import React from "react";

import styles from "./layouts.module.scss";

const GridView = ({ children, width, rowSpacing, columnSpacing, alignment }) => {
  const widgetStyles = {
    rowGap: `${rowSpacing}px`, 
    columnGap: `${columnSpacing}px`,
    gridTemplateColumns: `repeat(auto-fit, ${width})`,
    justifyContent: alignment
  }
  
  return (
    <div
      className={styles.grid}
      style={widgetStyles}
    >
      {children}
    </div>
  );
};

export default GridView;
